<template>
  <div id="addstep" class="pb30">
    <Breadcrumb />
    <div class="font14">
      <p class="sub-title prl70 mt20">Design Engraving</p>
      <div class="content middle collect mb50"  v-loading="loading">
        <div class="cell" v-if="this.artworkLoaded">
          <div>
            <div class="container dflex" :class="{fcolumn: $store.getters.isVertical, frow: !$store.getters.isVertical}">
              <div class="row">
                <div class="col-xs-12 text-center mt30 inlineb mb30">
                  <div class="inlineb p10 w100">
                    <div ref="printMe" class="inlineb">
                      <AlbaPanel v-if="type=='alba'" />
                      <AriaPanel v-else-if="type=='aria'" />
                      <AxesPanel v-else-if="type=='axes'" />
                      <BlackJackPanel v-else-if="type == 'blackjack'" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row prl70" :class="{pt40 : $store.getters.isVertical}">
                <div class="text-center">
                  <el-tabs type="card" value="Icons And Text">
                    <el-tab-pane name="Icons And Text" class="mt20">
                      <span slot="label">Icons And Text</span>
                      <IconAndFontSizePanel />
                    </el-tab-pane>

                    <el-tab-pane name="Buttons" class="mt20">
                      <span slot="label">Buttons</span>
                      <ContentEditPanel />
                    </el-tab-pane>

                    <el-tab-pane name="Alignment" v-if="type=='alba' || (type=='blackjack' && this.$store.getters.squareOrRectangle == 'rectangle')" class="mt20">
                      <span slot="label">Alignment</span>
                      <AlignmentPanel />
                    </el-tab-pane>

                    <el-tab-pane name="Color" class="mt20">
                      <span slot="label">Backlight Color</span>
                      <ColorPanel />
                    </el-tab-pane>

                  </el-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
// import logoURL from "@/assets/images/logo.png"
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import IconAndFontSizePanel from "./Panel/IconAndFontSizePanel";
import ContentEditPanel from "./Panel/ContentEditPanel";
import ColorPanel from "./Panel/ColorPanel";
import AlignmentPanel from "./Panel/AlignmentPanel";
import AlbaPanel from "./Panel/AlbaPanel";
import AriaPanel from "./Panel/AriaPanel";
import AxesPanel from "./Panel/AxesPanel";
import BlackJackPanel from "./Panel/BlackJackPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";
import axios from "axios";

export default {
  name: "s5",
  components: {
    IconAndFontSizePanel,
    Breadcrumb,
    ContentEditPanel,
    ColorPanel,
    AlignmentPanel,
    AlbaPanel,
    AriaPanel,
    AxesPanel,
    BlackJackPanel
  },
  mixins: [artworkToProductMixin],
  data() {
    return {
      format: null,
      output: null,
      previewMode: false,
      file: "",
      image: "",
      align: "left",
      loading: null,
      artworkLoaded: false,
    };
  },

  methods: {
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({ path: "/collection/style/" + this.routeParamArtworkId });
    },
    async next() {
      this.$store.commit("getProductCode");
      const el = this.$refs.printMe;
      const options = {
        type: "dataURL",
        scale: 2,
        backgroundColor:null
      };
      this.$store.state.artwork.img = await this.$html2canvas(el, options);
      this.$router.push({ path: "/collection/configuration/" + this.routeParamArtworkId });
    },
    async getArtwork() {
      this.loading = true;
      this.$store.editedIdArtworkTool = this.$route.params.aid;
      var response = await axios.get("open/artwork/single/" + this.routeParamProductId);
      this.$store.state.artwork = response.data;
          
      this.artworkLoaded = true;
      this.loading = false;
    }
  },

  created: function() {
    this.$parent.headerB();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 6;
    
    if (this.$route.params.aid && this.$store.editedIdArtworkTool != this.$route.params.aid) {
      this.getArtwork();
    } else {
      this.artworkLoaded = true;
      if (!this.$store.state.artwork.type) {
        alert("Please go to the start page");
        this.$router.push({ path: "/collection/" });
      }
    }
    this.format = this.$store.state.artwork.format;
  },
  computed: {
    type() {
      return this.$store.state.artwork.type;
    }
  }
};
</script>

<style lang="css" scoped>
.nav-footer{
  border-top:1px solid #ccc;
}
</style>
